<body class="main" *ngIf="!pdf">
    <div [ngClass]="errorOrNot ? 'errorcurve' : 'curve'"></div>
    <div class="transaction">
        <span style="height: 8vh;">
            <img src="../../../../assets/image/payment/successfull.svg" alt="" *ngIf="!errorOrNot">
            <img src="../../../../assets/image/payment/error.svg" alt="" *ngIf="errorOrNot">
        </span>
        <span style="font-weight: 600;" *ngIf="!errorOrNot">Payment Successfull</span>
        <span style="font-weight: 600;" *ngIf="errorOrNot">Transaction Error</span>
        <div class="upperBorder">
            <span class="image"><img src="../../../../assets/image/payment/studentIcon.svg" alt=""></span>
            <span style="width: 70%;display: flex; gap: 20px; padding-left: 20px;justify-content: center;">
                <span
                    style="width: 100%;display: flex;flex-direction: column;justify-content: center; align-items: start; height: 100%;">
                    <span style="font-size: 12px;">Application No</span>
                    <span style="font-size: 12px;">{{data.admNo}}</span>
                </span>
            </span>
        </div>
    </div>
    <div class="details">
        <div class="data" style="display: flex;">
            <span class="subData">
                <span>Aplication No</span>
                <span>{{data.admNo}}</span>
            </span>
            <span class="subData">
                <span>Amount (Rs)</span>
                <span>{{paymentAmount}}</span>
            </span>
        </div>
        <div class="data">
            <span class="subData">
                <span>Mobile No</span>
                <span>{{data.mobileNo}}</span>
            </span>
            <span class="subData">
                <span>Transaction Confirmation</span>
                <span>{{data.status}}</span>
            </span>
        </div>
        <div class="data">
            <span class="subData">
                <span>Bank Receipt No</span>
                <span>{{data.referenceId}}</span>
            </span>
        </div>
        <div class="data">
            <span class="subData">
                <span>Bank Transaction No</span>
                <span>{{data.clientTransactionNo}}</span>
            </span>
        </div>
        <div class="data">
            <span class="subData">
                <span>Client Transaction No</span>
                <span>{{data.clientTransactionNo}}</span>
            </span>
        </div>
        <div class="data">
            <span class="subData">
                <span>Transaction Date</span>
                <span>{{data.transactionDate}}</span>
            </span>
        </div>
    </div>
    <div class="button" *ngIf="!errorOrNot">
        <button (click)="downlodPdf()">PDF</button>
    </div>
</body>

<body class="main" *ngIf="pdf">
    <div style="width:100%; height:90vh;">
        <iframe [src]="pdfUrl | safe" style="width:100%; height:100%; border:none;"></iframe>
    </div>

    <a [href]="pdfUrl" download target="_blank">Download PDF</a>

</body>

<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>